import { Divider, type ButtonSizeType } from '@design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { PreAuthSoldOutOfferButton } from '../../../../features/offers/components/PreAuthSoldOutOfferButton';
import {
  getProductRef,
  getProductStatus,
} from '../../../../helpers/purchasing';
import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import type { ButtonLocation } from '../../../../types/Subscriptions';
import { SignUpButton } from '../SignUpButton';

type Props<T extends ProductPurchaseDetails> = {
  buttonLocation?: ButtonLocation;
  buttonSize?: ButtonSizeType;
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
};

export const SoldOutSubscriptionCta: React.FC<
  Props<ProductPurchaseDetails>
> = ({ buttonLocation, buttonSize, product, purchasingController }) => {
  const { t } = useTranslation('product');

  return (
    <div className="flex w-full flex-col gap-6">
      <p className="text-center text-neutral-4">{t('soldout')}</p>

      <Divider variant="dashed" />

      <div>
        <p className="text-center font-bold">
          {t('subscriptionCta.soldOut.title')}
        </p>
        <p className="text-center">
          {!product.offersDisabled
            ? t('subscriptionCta.soldOut.offers.body')
            : t('subscriptionCta.soldOut.body')}
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {!product.offersDisabled ? (
          <PreAuthSoldOutOfferButton product={product} />
        ) : null}
        <SignUpButton
          buttonLocation={buttonLocation}
          isSoldOut
          labels={{
            normal: t('subscriptionCta.soldOut.buttonTitle'),
            success: t('subscriptionCta.soldOut.buttonSuccessTitle'),
          }}
          product={product}
          productRef={getProductRef(purchasingController)}
          productStatus={getProductStatus(product, purchasingController)}
          size={buttonSize}
          variant={!product.offersDisabled ? 'secondary' : 'primary'}
        />
      </div>
    </div>
  );
};
